module.exports = __webpack_public_path__ + "static/media/location-pin.4590ec55.svg";